/* unplugin-vue-components disabled */import { render } from "./logistics-list.vue?vue&type=template&id=ae659ff4&scoped=true"
import script from "./logistics-list.vue?vue&type=script&lang=js"
export * from "./logistics-list.vue?vue&type=script&lang=js"

import "./logistics-list.vue?vue&type=style&index=0&id=ae659ff4&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/amoeba-logistics-information-system-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae659ff4"]])

export default __exports__